<h1>Scenarios & Personas</h1>

<p>
    Select one of the scenarios/personas below to see how the application behaves and communicates in different
    circumstances.
</p>

<div class="row mb-4 p-2">
    @for (case of cases; track case) {
    <div class="col-12 col-sm-6 col-md-4 col-xl-3 p-1">
        <div class="card mb-3">
            <div class="card-header {{case?.cssClass}}"></div>
            <div class="card-body">
                <h5 class="card-title text-uppercase">{{case?.header}}</h5>
                <h6 class="card-title">{{case?.description}}</h6>
                <p class="card-text">{{case?.outcome}}</p>

                <div class="btn-group me-3">
                    <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
                        <button type="button" class="btn btn-outline-primary" (click)="navigate(case.accountId, 'dashboard')">Risk profile</button>
                        <button type="button" class="btn btn-outline-primary dropdown-toggle-split" ngbDropdownToggle></button>
                        <div class="dropdown-menu" ngbDropdownMenu>
                            <button ngbDropdownItem (click)="navigate(case.accountId, 'messages')">messages</button>
                            @for (dialog of dialogs; track dialog) {
                                <button ngbDropdownItem (click)="navigate(case.accountId, dialog)">{{dialog}}</button>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    } @empty {
    <div class="col-12 col-md-4 col-lg-3 m-1">
        <div class="card mb-3">
            <div class="card-header bg-primary"></div>
            <div class="card-body">
                <h5 class="card-title text-uppercase">No data</h5>
                <h6 class="card-title">No data</h6>
                <p class="card-text">No data</p>
            </div>
        </div>
    </div>
    }
    <div class="col-12 col-sm-6 col-md-4 col-xl-3 p-1">
        <div class="card mb-3">
            <div class="card-header bg-success"></div>
            <div class="card-body">
                <h5 class="card-title text-uppercase">Empty</h5>
                <h6 class="card-title">Empty</h6>
                <p class="card-text">Empty</p>
                <a class="btn btn-primary text-uppercase text-light fw-bold" (click)="navigate(123999, 'dashboard')">Risk profile</a>
                <a class="btn btn-link text-uppercase text-light fw-bold" (click)="navigate(123999, 'messages' )">Messages</a>
                <a class="btn btn-link text-uppercase text-light fw-bold" (click)="navigate(123999, 'gamtest')">Gamtest</a>
            </div>
        </div>
    </div>

</div>
